import { NetworkPointResource } from 'app/_resources/network-point.resource';
import { Growl } from 'angular/custom/services/growl.service';
import { ErrorHandler } from 'app/_services/error-handler.factory';
import * as angular from 'angular';
import { config } from 'angular/utils/config';
import { CapacityManagementService } from 'app/_services/capacityManagementService';
import { OrganisationService } from 'app/_services/organisationService';

class NetworkPointDetailsCtrl implements ng.IController {
    constructor(
        private $window,
        private $rootScope,
        private NetworkPoint: NetworkPointResource,
        private authService,
        private growl: Growl,
        private $location: ng.ILocationService,
        private errorHandler: ErrorHandler
    ) {}

    public networkPointId: number;
    public networkPoint: NetworkPointDto;
    public loggedInUser: LoginResult;
    public uiLoading: boolean = true;
    public uiLoadingError: boolean = false;
    public isCreateMode: boolean =
        this.$location.path().indexOf('/network-point/create') > -1;

    public tsoOnCapacityManagementStage = false;
    public shipperOnCapacityManagementStage = false;
    public usesCapacityManagement = false;
    public appBaseUrl = config.appBaseUrl;

    public canSeeAvailabilityAndPriceData = false;
    public canSeeCaMaCapacityOverview = false;

    public tsoCompanyName: string;

    public hasPublicCapacityPool: boolean = false;

    async $onInit() {
        const loginResult: LoginResult =
            await this.authService.userLoginPromise.promise.catch(
                () => {} // unauthenticated
            );

        // if we have a login result but no role, we want to loginResult to be falsy so that the user does not see what a tso with role would see
        this.loggedInUser =
            loginResult && loginResult.role ? loginResult : null;

        if (this.loggedInUser && this.loggedInUser.role === 'TSO_USER') {
            this.tsoCompanyName = this.loggedInUser.tsoName;
        } else {
            if (
                !this.loggedInUser &&
                loginResult &&
                loginResult.currentlyActingWithOrganisationRole === 'TSO'
            ) {
                const orgService: OrganisationService =
                    this.$rootScope.organisationService;
                const myOrgDetails =
                    await orgService.getMyOrganisationDetails();
                this.tsoCompanyName = myOrgDetails.companyName;
            }
        }
        const camaService: CapacityManagementService =
            this.$rootScope.camaService;
        const cama = await camaService.data;
        if (cama) {
            this.usesCapacityManagement = Boolean(cama.isCaMaSubscribedTso);

            this.canSeeCaMaCapacityOverview = Boolean(
                cama._links && cama._links.capacityGraph
            );

            if (this.usesCapacityManagement === true) {
                this.canSeeAvailabilityAndPriceData = Boolean(
                    cama._links && cama._links.viewAvailabilityAndPriceData
                );
            }
        }

        this.shipperOnCapacityManagementStage =
            camaService.accessible &&
            this.loggedInUser &&
            this.loggedInUser.currentlyActingWithOrganisationRole === 'SHIPPER';

        this.tsoOnCapacityManagementStage =
            camaService.accessible &&
            loginResult.currentlyActingWithOrganisationRole === 'TSO';

        if (
            !this.isCreateMode ||
            (this.isCreateMode && !!this.networkPointId)
        ) {
            this.getNetworkPoint();
        } else {
            this.uiLoading = false;
        }
    }

    private isUserPartOfBundle(): boolean {
        if (this.networkPoint && this.networkPoint.direction == 'BUNDLE') {
            return (
                this.loggedInUser.referenceId == this.networkPoint.tso0Id ||
                this.loggedInUser.referenceId == this.networkPoint.tso1Id
            );
        }
        return false;
    }

    public getNetworkPoint(): void {
        let param = {
            id: this.networkPointId,
            version: this.$location.search().version || <VersionDto>'CURRENT',
            'include-links': true,
            'include-selling-methods': true
        };
        this.NetworkPoint.get(
            param,
            (res) => {
                this.networkPoint = res;
            },
            (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                if (err.status == 404) {
                    // if an alternative is present, the endpoint return an 404 with Version
                    if (err.headers('Version')) {
                        this.$location.search(
                            'version',
                            err.headers('Version')
                        );

                        this.growl.show(
                            `There is no ${param.version.toLowerCase()} version. Showing ${
                                param.version === 'CURRENT'
                                    ? 'future'
                                    : 'current'
                            } version instead.`,
                            'warning',
                            { delay: 2000 }
                        );
                    } else {
                        this.growl.show(
                            `There is no network point with id: ${param.id}`,
                            'danger',
                            { delay: 2000 }
                        );
                    }
                } else {
                    this.errorHandler(err);
                }
            }
        ).$promise.then(() => {
            const isOwningTso =
                this.loggedInUser &&
                this.loggedInUser.role === 'TSO_USER' &&
                this.networkPoint &&
                (this.loggedInUser.referenceId == this.networkPoint.tso0Id ||
                    this.loggedInUser.referenceId == this.networkPoint.tso1Id);

            if (!isOwningTso) {
                this.$location
                    .path(
                        `/react/transport/network-points/${this.networkPointId}`
                    )
                    .replace();
                return;
            }

            this.NetworkPoint.getCapacityPools(
                { id: this.networkPoint.networkPointUuid },
                (res) => {
                    this.hasPublicCapacityPool = res.length > 0;
                    this.uiLoading = false;
                },
                (err: ng.IHttpPromiseCallbackArg<RestError>) => {
                    this.errorHandler(err);
                }
            );
        });
    }

    public goBack(): void {
        this.$window.history.back();
    }

    public appLink($event: any) {
        console.log($event);
        $event.preveltDefault();
    }
}

angular.module('app').component('pkpNetworkPointDetailsPage', {
    controller: NetworkPointDetailsCtrl,
    template: require('app/network-point/network-point-details.component.html'),
    bindings: {
        networkPointId: '<?'
    }
});
